import ReactDOM from 'react-dom';
import React from 'react';
import Router from './library/DomBasedRouter';
import Organizations from './components/Organizations';
import PerformanceReports from './components/PerformanceReports';
import Tabs from './library/Tabs';
import axios from 'axios';
import Qs from 'qs';
import $ from 'jquery';
import 'babel-polyfill';
import Stickyfill from 'stickyfilljs';
import loadPDFs from './library/loadPDFs'
window.$ = $

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

const router = new Router({
  common: {
    init() {
      Stickyfill.add(document.querySelector('header'))
      
      if (document.querySelectorAll('.tabbed').length) {
        Tabs();
      }

      const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
      const mobileMenuClose = document.querySelector('.mobile-menu-close');
      const mobileMenu = document.querySelector('.mobile-menu-wrapper');

      if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener(
          'click',
          (e) => {
            e.stopPropagation();
            mobileMenu.classList.toggle('open');
          },
          false,
        );
      }

      $('.mobile-menu-close').click((e) => {
        $('.mobile-menu-wrapper').removeClass('open');
      });

      $('.mobile-menu-wrapper').click((e) => {
        e.stopPropagation();
      });

      $('body').click((e) => {
        if ($('.mobile-menu-wrapper').hasClass('open')) {
          $('.mobile-menu-wrapper').removeClass('open');
        }
      });

      $('.mobile-menu-wrapper li.menu-item-has-children > a').click((e) => {
        e.preventDefault();
        $(e.target)
          .parents('li')
          .toggleClass('showing-children');
      });

      $('footer .lower a').each((i, el) => {
        $(el).attr('data-inner-text', $(el).text());
      });
    },
  },
  home: {
    init() {},
  },
  'closed-investments': {
    init() {
      ReactDOM.render(
        <Organizations {...window.themeFilter} />,
        document.querySelector('#organization-filter'),
      );

      /* Scroll to section functionality */
      const scrollToPipelineSection = (e) => {
        let headerHeight = document.querySelector('header').offsetHeight;
        if (window.innerWidth >= 1226) {
          headerHeight += document.querySelector('.pipeline-filter').offsetHeight;
        }
        setTimeout(() => {
          $('html, body').animate({
            scrollTop:
              document.querySelector('.single-pipeline-stage.open').offsetTop - headerHeight,
          });
        }, 100);
      };
      [...document.querySelectorAll('.pipeline-filters-list a')].forEach((a, i) => {
        a.addEventListener('click', scrollToPipelineSection);
      });

      [...document.querySelectorAll('.single-pipeline-stage a.title')].forEach((a, i) => {
        a.addEventListener('click', scrollToPipelineSection);
      });
    }
  },
  pipeline: {
    init() {
      ReactDOM.render(
        <Organizations {...window.themeFilter} />,
        document.querySelector('#organization-filter'),
      );

      // const domainAccordion = (e) => {
      //   const bar = $(e.target).closest('.domain')[0];

      //   if (!bar.classList.contains('active')) {
      //     document.querySelector('.domain.active').classList.remove('active');
      //     bar.classList.add('active');
      //   }
      // };

      // [...document.querySelectorAll('.domains-filter .domain .title-bar')].forEach((x) => {
      //   x.addEventListener('click', domainAccordion);
      // });

      /* Scroll to section functionality */
      const scrollToPipelineSection = (e) => {
        let headerHeight = document.querySelector('header').offsetHeight;
        if (window.innerWidth >= 1226) {
          headerHeight += document.querySelector('.pipeline-filter').offsetHeight;
        }
        setTimeout(() => {
          $('html, body').animate({
            scrollTop:
              document.querySelector('.single-pipeline-stage.open').offsetTop - headerHeight,
          });
        }, 100);
      };
      [...document.querySelectorAll('.pipeline-filters-list a')].forEach((a, i) => {
        a.addEventListener('click', scrollToPipelineSection);
      });

      [...document.querySelectorAll('.single-pipeline-stage a.title')].forEach((a, i) => {
        a.addEventListener('click', scrollToPipelineSection);
      });
    },
  },
  investments: {
    init() {
      ReactDOM.render(
        <Organizations {...window.themeFilter} />,
        document.querySelector('#organization-filter'),
      );
      $('body').on('click', '.single-pipeline-stage.open .title-bar', () => {
        $('.single-pipeline-stage.open').removeClass('open');
      });

      const scrollToPipelineSection = (e) => {
        const headerHeight = document.querySelector('header').offsetHeight;

        setTimeout(() => {
          $('html, body').animate({
            scrollTop:
              document.querySelector('.single-pipeline-stage.open').offsetTop - headerHeight,
          });
        }, 100);
      };

      $('body').on(
        'click',
        '.single-pipeline-stage:not(.open) button.title-bar',
        scrollToPipelineSection,
      );
    },
  },
  'post-type-archive-performance_reports': {
    init() {
      ReactDOM.render(
        <PerformanceReports {...window.themeFilter} />,
        document.querySelector('#filter-reports'),
      );
    },
  },
  'single-performance_reports': {
    init() {
      ReactDOM.render(
        <PerformanceReports {...window.themeFilter} />,
        document.querySelector('#filter-reports'),
      );
    },
  },
  'post-type-archive-partner_meetings': {
    init() {
      if ($('.load-more').length) {
        $('.load-more').click((e) => {
          if ($('.expanding-block.hidden').length) {
            setTimeout(() => {
              $('.expanding-block.hidden')
                .slice(0, 4)
                .removeClass('hidden');

              if (!$('.expanding-block.hidden').length) {
                $('.load-more').remove();
              }
            }, 300);
          }
        });
      }
    },
  },
  'single-partner_meetings': {
    init() {
      
      loadPDFs()
      
      Stickyfill.add(document.querySelector('.aside-inner'))
      
      // [...document.querySelectorAll('.canvas-pdf-wrapper')].forEach((pdfCanvas) => {
      //   console.log(pdfCanvas.dataset.url);
      // });

      const panes = [...document.querySelectorAll('.pane section')];
      const listItems = [...document.querySelectorAll('aside li')];

      const setAsideSelection = (e) => {
        const t = document.documentElement.scrollTop + window.innerHeight / 2;
        let c = 0;
        for (let i = 0; i < panes.length; i++) {
          if (panes[i].offsetTop > t) {
            c = i > 0 ? i - 1 : i;
            break;
          } else if (i === panes.length - 1) {
            c = panes.length - 1;
            break;
          }
        }
        listItems.forEach((li) => {
          li.classList.remove('active');
        });
        if (document.querySelector('aside li.active')) {
          document.querySelector('aside li.active').classList.remove('active');
        }
        // console.log(listItems);
        c = c > listItems.length - 1 ? listItems.length - 1 : c;
        listItems[c].classList.add('active');
      };
      window.addEventListener('scroll', setAsideSelection);
      setAsideSelection();

      $('.toggle-sidebar').click((e) => {
        $('.single-partner-meeting-group').toggleClass('menu-open');
      });

      [...document.querySelectorAll('aside ul a')].forEach((x) => {
        
        

        /* Scroll to Section */
        x.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          // if (document.querySelector('.menu-open')) {
          //   document.querySelector('.menu-open').classList.remove('menu-open');
          // }
          const elementTop = document.querySelector(e.target.getAttribute('href')).offsetTop;
          const headerHeight = document.querySelector('header').offsetHeight;
          const pageTitle = document.querySelector('.page-title').offsetHeight;

          $('html, body').animate({
            scrollTop: elementTop + pageTitle,
          });
        });
      });


      /* Add Script to Call Download All */
      // const deletePaths = [];
      // document.querySelector('.download-all').addEventListener('click', (e) => {
      //   e.preventDefault();
      //   axios({
      //     url: window.bmp.ajaxurl,
      //     method: 'POST',
      //     // responseType: 'json',
      //     data: Qs.stringify({
      //       action: 'download_all_meeting_materials',
      //       printLogIn: window.bmp.ajax_nonce,
      //       id: parseInt([...document.body.classList]
      //         .filter(x => x.indexOf('postid-') === 0)[0]
      //         .split('postid-')[1]),
      //     }),
      //   }).then((response) => {
      //     const { file, deletePath } = response.data;
      //     const downloadURL = `/wp-content/${file.split('wp-content')[1]}`;
      //     deletePaths.push(deletePath);

      //     // To Download
      //     // const url = window.URL.createObjectURL(new Blob([response.data]));
      //     const link = document.createElement('a');
      //     link.href = downloadURL;
      //     link.setAttribute('download', '');
      //     document.body.appendChild(link);
      //     link.click();
      //   });
      // });

      window.addEventListener('unload', (e) => {
        axios({
          url: window.bmp.ajaxurl,
          method: 'POST',
          data: Qs.stringify({
            action: 'delete_partner_meeting_download',
            deletePaths,
          }),
        });
      });
    },
  },
  'single-accordion-list': {
    init() {
      [...document.querySelectorAll('.single-accordion-list__item .title-bar')].forEach((domain) => {
        domain.addEventListener('click', (e) => {
          const domain = $(e.target).closest('.single-accordion-list__item');
          const alreadyOpen = $('.single-accordion-list__item.open');
          if (alreadyOpen.length) {
            if (domain.hasClass('open')) {
              domain.removeClass('open');
            } else {
              alreadyOpen.removeClass('open');
              domain.addClass('open');
              setTimeout(() => {
                $('html, body').animate({
                  scrollTop: $(domain).offset().top - $('header')[0].offsetHeight,
                });
              }, 100);
            }
          } else {
            domain.addClass('open');
            setTimeout(() => {
              $('html, body').animate({
                scrollTop: $(domain).offset().top - $('header')[0].offsetHeight,
              });
            }, 100);
          }
        });
      });
    },
  },
  'key-documents-sidebar': {
    init() {
      [...document.querySelectorAll('.summary')].forEach((x) => {
        x.addEventListener('click', (e) => {
          $(e.target)
            .closest('.details')
            .toggleClass('open');
        });
      });
    },
  },
});
router.load();

function windowOffset(el) {
  const rect = el.getBoundingClientRect();
  return { top: rect.top, left: rect.left };
}
